"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, r, t, n, a, u, i) {
  try {
    var o = e[u](i),
      c = o.value;
  } catch (e) {
    return void t(e);
  }
  o.done ? r(c) : Promise.resolve(c).then(n, a);
}
function _asyncToGenerator(e) {
  return function () {
    var r = this,
      t = arguments;
    return new Promise(function (n, a) {
      var u = e.apply(r, t);
      function i(e) {
        asyncGeneratorStep(u, n, a, i, o, "next", e);
      }
      function o(e) {
        asyncGeneratorStep(u, n, a, i, o, "throw", e);
      }
      i(void 0);
    });
  };
}
var dbId,
  classChartDataArray,
  convert = require("xml-js"),
  flatten = require("flat"),
  unflatten = require("flat").unflatten,
  Utility = require("./Utility.module"),
  Leads = require("./Leads.module"),
  CriticalInput = require("./CriticalInput.service"),
  GlobalConstantsVariables = require("./GlobalConstantsVariables"),
  axios = require("axios"),
  ESTIMATOR_WHATIFS_API1_LAMBDA = CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA || "dwellingcost5-Lambda-SCOMW3US0YHS",
  ESTIMATOR_WHATIFS_API2_LAMBDA = CriticalInput.ESTIMATOR_WHATIFS_API2_LAMBDA || "WhatIfScenarioLambdaV2",
  urlmapper = require("./UrlMapper.service"),
  CLASS_NAME = "ComponentHelper:",
  CAN_BE_CACHED_KEYS = ["stateCode", "livingsizeSqft", "calculatedCoverage", "utilityAmount", "propertyTaxAmount", "mortgageAmount", "avmAmount", "listingPriceAmount", "agentBrandingCode"];
console.log("Loading Lib Class: ", CLASS_NAME);
var classLevelHash = {};
function genericApiCall(e) {
  return _genericApiCall.apply(this, arguments);
}
function _genericApiCall() {
  return (_genericApiCall = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
    var t,
      n,
      a,
      u,
      i,
      o = arguments;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return t = o.length > 1 && void 0 !== o[1] ? o[1] : {}, n = "https://api3.getmybubble.io/library", a = "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? "stage" : "production", u = {
            library_function: r,
            arguments: t,
            environment: a
          }, e.prev = 4, e.next = 7, axios.post(n, u);
        case 7:
          return i = e.sent, e.abrupt("return", i.data);
        case 11:
          return e.prev = 11, e.t0 = e.catch(4), e.abrupt("return", {});
        case 14:
        case "end":
          return e.stop();
      }
    }, e, null, [[4, 11]]);
  }))).apply(this, arguments);
}
module.exports = {
  calculateAndSaveUtilityAmount: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("calculateAndSaveUtilityAmount", {
              item: r,
              onChangeItem: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  processCalculateAndCache: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("processCalculateAndCache", {
              item: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  saveAppData: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("saveAppData", {
              item: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  saveUpdateClientData: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      var n,
        a = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return n = !(a.length > 2 && void 0 !== a[2]) || a[2], e.next = 3, genericApiCall("saveUpdateClientData", {
              clientId: r,
              item: t,
              isItemFromGetAppdata: n
            });
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  recalculateLifeInsuranceAmount: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      var n,
        a,
        u,
        i,
        o,
        c,
        s = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return n = s.length > 2 && void 0 !== s[2] ? s[2] : 7e5, a = s.length > 3 && void 0 !== s[3] ? s[3] : "CA", u = s.length > 4 && void 0 !== s[4] ? s[4] : "30", i = s.length > 5 && void 0 !== s[5] ? s[5] : "1", o = s.length > 6 && void 0 !== s[6] ? s[6] : 0, c = s.length > 7 && void 0 !== s[7] ? s[7] : 20, e.next = 8, genericApiCall("recalculateLifeInsuranceAmount", {
              inputIdWithoutAddress: r,
              inputIdWithAddress: t,
              coverageAmount: n,
              stateCode: a,
              age: u,
              gender: i,
              isSmoker: o,
              termLength: c
            });
          case 8:
            return e.abrupt("return", e.sent);
          case 9:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  setDataInCache: function (e, r) {
    return genericApiCall("setDataInCache", {
      key: e,
      value: r
    });
  },
  getCachedData: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getCachedData", {
              key: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getCachedData2: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getCachedData2", {
              key: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getDwellingCost: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getDwellingCost", {
              inputAddressDeatils: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  fetchAndSaveHomeInsurance: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("fetchAndSaveHomeInsurance", {
              inputJson: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getDwellingCostRecursive: function (e, r) {
    return genericApiCall("getDwellingCostRecursive", {
      id: e,
      callbackMethodObject: r
    });
  },
  saveAppDataAndCache: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("saveAppDataAndCache", {
              inputJson: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  updateAppDataAndCache: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("updateAppDataAndCache", {
              dataCategory: r,
              inputJson: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getPhotoReference: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getPhotoReference", {
              inputJson: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getQuotesFromStillWater: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getQuotesFromStillWater", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getMinimalHomeQuoteFromStillWater: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getMinimalHomeQuoteFromStillWater", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getBindFromStillWater: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getBindFromStillWater", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getQuotesFromSBLIAfficiency: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      var n,
        a,
        u,
        i,
        o,
        c,
        s,
        p = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return n = p.length > 2 && void 0 !== p[2] ? p[2] : "SBLI_getQUOTE", a = p.length > 3 ? p[3] : void 0, u = p.length > 4 ? p[4] : void 0, i = "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? "DEV" : "PROD", o = n.split("_")[1], c = "https://bo.getmybubble.co/api/app-tracking/track-apis", s = {
              client_id: a,
              email_id: "",
              phone: "",
              action_type: "api",
              full_name: "",
              carrier: u,
              lob: "life",
              functionality_group: o,
              session_id: "",
              api_group_id: "",
              dynamodb_id: t,
              tags: "",
              environment: i
            }, axios.post(c, s), e.next = 10, genericApiCall("getQuotesFromSBLIAfficiency", {
              inputJson: r,
              uid: t,
              data_category: n
            });
          case 10:
            return e.abrupt("return", e.sent);
          case 11:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getWNSPayment: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getWNSPayment", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getGoogleFormattedData: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getGoogleFormattedData", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getBubbleFormattedAddress: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getBubbleFormattedAddress", {
              address_components: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getQuotesFromPaclife: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getQuotesFromPaclife", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getStateAverageCostSqft: function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "VT",
      r = require("./../../../../state_average_cost_sqft.json");
    return r[e];
  },
  isAlive: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("isAlive", {
              serverName: r,
              key: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getAppData: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      var t;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t = {
              idorUid: r
            }, e.next = 3, genericApiCall("getAppData", t);
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getAppData4Ids: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getAppData4Ids", {
              idsCommaSeparated: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getCoverageRecommendation: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t, n, a) {
      var u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return "https://api2.getmybubble.io", u = "".concat("https://api2.getmybubble.io", "/fetch1?fun=CoverageRecommendation&dget1=").concat(r, "&dget2=").concat(t, "&dget3=").concat(n, "&dget4=").concat(a), e.abrupt("return", axios.get(u).then(function (e) {
              return e;
            }).catch(function (e) {
              return e;
            }));
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t, n, a) {
      return e.apply(this, arguments);
    };
  }(),
  getPacLifeRiskClass: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t, n, a) {
      var u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return "https://api2.getmybubble.io", u = "".concat("https://api2.getmybubble.io", "/fetch1?data_category=PacLifeRiskClass&dget1=").concat(r, "&dget2=").concat(t, "&dget3=").concat(n, "&dget4=").concat(a), e.abrupt("return", axios.get(u).then(function (e) {
              return e;
            }).catch(function (e) {
              return e;
            }));
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t, n, a) {
      return e.apply(this, arguments);
    };
  }(),
  getServicingStates: function () {
    return genericApiCall("getServicingStates");
  },
  hubSpotSync: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = JSON.parse(r), e.next = 3, genericApiCall("hubSpotSync", {
              inputJson: r
            });
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  hubSpotCheckEmail: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = JSON.parse(r), e.next = 3, genericApiCall("hubSpotCheckEmail", {
              inputJson: r
            });
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  hubspotInsertOrUpdate: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("hubspotInsertOrUpdate", {
              inputJson: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  hubSpotUpdate: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = JSON.parse(r), e.next = 3, genericApiCall("hubSpotUpdate", {
              inputJson: r
            });
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  callMethodByName: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            try {
              t = JSON.parse(t);
            } catch (e) {
              t = t;
            }
            return e.next = 3, genericApiCall(r, {
              data: t
            });
          case 3:
            return e.abrupt("return", e.sent);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getbrushForestAPI: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getbrushForestAPI", {
              inputJson: r,
              uid: t
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getTrackedApplications: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getTrackedApplications", {
              inputJson: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getPaclifeURL: function (e) {
    return CriticalInput.PACLIFE_BASE_URL ? CriticalInput.PACLIFE_BASE_URL : "https://stage.getmybubble.io";
  },
  getCustomerId4Email: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getCustomerId4Email", {
              dget3: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  getGoogleAddressDetails: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("getGoogleAddressDetails", {
              address: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  doAxiosPatchCall: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("doAxiosPatchCall", {
              data: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  doAxiosPostCall: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("doAxiosPostCall", {
              data: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  doAxiosGetCall: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, genericApiCall("doAxiosGetCall", {
              data: r
            });
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }(),
  bo_log: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r, t) {
      var n, a, u, i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            n = {
              api: "track-apis",
              page: "track-pages",
              event: "track-events",
              landing: "track-page-landing"
            }, a = "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? "DEV" : "PROD", u = "https://bo.getmybubble.co/api/app-tracking/" + n[t], (i = r).environment = a, axios.post(u, i);
          case 6:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (r, t) {
      return e.apply(this, arguments);
    };
  }(),
  getCarrierConfigBo: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(r) {
      var t, n;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return "https://bo.getmybubble.co/api/coverage-config/all-configs", t = r, e.prev = 2, e.next = 5, axios.post("https://bo.getmybubble.co/api/coverage-config/all-configs", t);
          case 5:
            return n = e.sent, console.log(n.data), e.abrupt("return", n.data);
          case 10:
            return e.prev = 10, e.t0 = e.catch(2), console.error("genericApiCall", e.t0.message), e.abrupt("return", {});
          case 14:
          case "end":
            return e.stop();
        }
      }, e, null, [[2, 10]]);
    }));
    return function (r) {
      return e.apply(this, arguments);
    };
  }()
};